import t from "@/lang/lang";
import { useParams } from "react-router";
import {
  OfflineState,
  useOfflineContext,
} from "../_components/offline-context";
import { SamplesForDeliveryCard } from "@/services/backend/samples/components/samples-for-delivery";
import { useListPosition } from "../_components/use-work-order-positions-offline";
import { AlertTriangle } from "lucide-react";
import { HTZ_WORK_ORDER_NAMESPACE } from "@/services/backend/htz/work-order/types/work-order";
import { FilterMode } from "@/shared/lib/filter/filter";
import { DeliveriesCard } from "@/services/backend/samples/components/deliveries-table";

export function LaboratoryRoute() {
  const { workOrderId } = useParams();
  const { offlineState } = useOfflineContext();
  const { data: positions } = useListPosition(workOrderId!);

  if (offlineState !== OfflineState.ONLINE) {
    return null;
  }

  return (
    <div className="grid gap-2">
      <SamplesForDeliveryCard
        documentId={workOrderId!}
        documentNamespace={HTZ_WORK_ORDER_NAMESPACE}
        initialRequest={{
          document: { active: true, values: [workOrderId!] },
          delivery: { active: true, mode: FilterMode.IsNull },
        }}
        // Show the position(s) where the sample was used.
        relatedEntity={(sample) => {
          if (!positions) return;

          const samplePositions = positions.filter((p) =>
            p.microbialAssessments.some((ma) => ma.sampleId === sample.id),
          );

          if (samplePositions.length === 0) {
            return (
              <span className="text-destructive flex gap-2">
                <AlertTriangle className="size-5" />
                {t("Probe ist mit keiner Position verknüpft")}
              </span>
            );
          }

          return samplePositions.map((pos) => pos.number).join(", ");
        }}
        getAssignment={(sample) => {
          if (!positions) return undefined;
          const samplePositions = positions.filter((p) =>
            p.microbialAssessments.some((ma) => ma.sampleId === sample.id),
          );
          return {
            positionNumbers: samplePositions.map((p) => p.number),
          };
        }}
      />
      <DeliveriesCard
        initialRequest={{ document: { active: true, values: [workOrderId!] } }}
      />
    </div>
  );
}
